import React, { useEffect, useState } from 'react';
import './VersionBadge.css';

const VersionBadge = () => {
  const [version, setVersion] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const resp = await fetch('/version.json', { cache: 'no-store' });
        if (!resp.ok) return;
        const data = await resp.json();
        if (mounted && data && data.version) setVersion(data.version);
      } catch (e) {
        // ignore
      }
    })();

    return () => { mounted = false; };
  }, []);

  if (!version) return null;

  return (
    <div className="version-badge" aria-hidden="true">
      {version}
    </div>
  );
};

export default VersionBadge;
